import { render, staticRenderFns } from "./InstockOutSel.vue?vue&type=template&id=b6f648c2&scoped=true&"
import script from "./InstockOutSel.vue?vue&type=script&lang=js&"
export * from "./InstockOutSel.vue?vue&type=script&lang=js&"
import style0 from "./InstockOutSel.vue?vue&type=style&index=0&id=b6f648c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6f648c2",
  null
  
)

export default component.exports